import {
  Zap,
  Droplets,
  Sparkles,
  Trash2,
  Calculator,
  ArrowUpDown,
  Phone,
  Wifi,
  Shield,
  Wrench,
  PaintRoller,
  Home,
  Fence,
  DoorClosed,
  AppWindow,
  Hammer,
  Building2,
  Paintbrush,
  Plug,
  Thermometer,
  FileText,
  Grid3x3,
} from 'lucide-react';

/**
 * Icon mapping for service types.
 * Maps icon names from the backend to Lucide React components.
 * The keys of this map are the only icon names the admin picker offers.
 */
export const ICON_MAP: Record<string, React.ElementType> = {
  Zap,
  Droplets,
  Sparkles,
  Trash2,
  Calculator,
  ArrowUpDown,
  Phone,
  Wifi,
  Shield,
  Wrench,
  PaintRoller,
  Home,
  Fence,
  DoorClosed,
  AppWindow,
  Hammer,
  Building2,
  Paintbrush,
  Plug,
  Thermometer,
  Grid3x3,
};

/** Sorted list of selectable icon names (used by the admin icon picker). */
export const ICON_NAMES: string[] = Object.keys(ICON_MAP).sort();

/**
 * Get icon component by name, with fallback to FileText
 */
export function getServiceIcon(iconName: string): React.ElementType {
  return ICON_MAP[iconName] || FileText;
}
